<template>
  <div class="cont_box">

    <!-- 배송 -->
    <div>
      <p class="address-tit">
        <span class="address-name"> 배송지 : {{ selectedDeliveryAddress.name }} </span>
        <span class="address-type" v-show="selectedDeliveryAddress.isRegularShipping">정기배송지</span>
        <span class="address-type" v-show="selectedDeliveryAddress.isDefault">기본배송지</span>
        <span class="btn-delivery-guide">
            <a class="bt-akl-blue sky mini" @click="displayModal = true">변경</a>
        </span>
      </p>
      <div class="address_info_txt">{{ selectedDeliveryAddress.formattedAddress }}</div>
      <div class="address_info_txt">휴대폰 : {{ formattedPhoneNumber }}</div>
      <div class="address_info_txt">배송메시지 : {{ selectedDeliveryAddress.message }} </div>
    </div>

    <popup-delivery-addresses
      :display-modal="displayModal"
      :delivery-list="deliveryList"
      :selected-delivery-address="selectedDeliveryAddress"
      @close-modal="closeModal"
      @select-delivery-address="storeDeliveryInfo"
    />

  </div>
</template>

<script>
import PopupDeliveryAddresses from "@/views/order/main/components/PopUpWrappers/PopupDeliveryAddresses";

export default {
  name: "DeliveryInfo",
  components: {
    PopupDeliveryAddresses,
  },
  props: {
    selectedDeliveryAddress: {
      type: Object,
      required: true
    },
    deliveryList: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    formattedPhoneNumber() {
      const areaCode = this.selectedDeliveryAddress.cellphone.substring(0, 3);
      const firstUnit = this.selectedDeliveryAddress.cellphone.length === 11 ?
        this.selectedDeliveryAddress.cellphone.substring(3, 7) : this.selectedDeliveryAddress.cellphone.substring(3, 6);
      const lastUnit = this.selectedDeliveryAddress.cellphone.length === 11?
        this.selectedDeliveryAddress.cellphone.substring(7) : this.selectedDeliveryAddress.cellphone.substring(6);

      return areaCode + "-" + firstUnit + "-" + lastUnit;
    },
    isDefaultDeliveryAddress() {
      return this.defaultAddressId !== ""
    }
  },
  data() {
    return {
      displayModal: false,
    }
  },
  methods: {
    closeModal(event) {
      this.displayModal = false;
    },
    storeDeliveryInfo(event) {
      this.$emit('store-delivery-info', event);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/main/components/Receive/DeliveryInfo.vue